import styled from 'styled-components'
import { Box } from '@usap/uicomponents'

const ArticleBox = styled(Box)`
  line-height: 1.5;
  border-bottom: ${({ isLast }) => (isLast ? 'none' : '1px solid #E0E0E0')};
  margin-bottom: 16px;
`

export default ArticleBox
